import { render } from "./poPdfFooter.vue?vue&type=template&id=7b3bf3b4"
import script from "./poPdfFooter.vue?vue&type=script&lang=js"
export * from "./poPdfFooter.vue?vue&type=script&lang=js"

import "./poPdfFooter.vue?vue&type=style&index=0&id=7b3bf3b4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__